import { TAG_NAME } from 'src/utils/constants/TagNameConstants';
import { IMAGE_PATH_AND_NAME } from 'src/utils/ImageHelper/ImagePathHelper';

import { ThumbnailTypes } from '../thumbnail/types';

interface mapBreakPointsWithTagsForRailsInterface {
  [key: string]: {
    [key: string]: number;
  };
}
export const getThumbnailOptions = (
  tags: string[]
): [keyof typeof IMAGE_PATH_AND_NAME, ThumbnailTypes] => {
  const tagName =
    tags?.length > 0 &&
    (tags?.includes(TAG_NAME.TVSHOWS) ||
      tags?.includes(TAG_NAME.NEWS_UNDERSCORE_TITLE))
      ? TAG_NAME.NEWS_COLLECTION
      : tags?.includes(TAG_NAME.PORTRAIT_UNDERSCORE_SMALL) ||
        tags?.includes(TAG_NAME.TOP_TEN) ||
        tags?.includes(TAG_NAME.PORTRAIT_UNDERSCORE_LARGE)
      ? TAG_NAME.PORTRAIT_SMALL
      : tags.includes(TAG_NAME.COLLECTION)
      ? TAG_NAME.COLLECTION
      : tags?.includes(TAG_NAME.ZEE5_MUSIC_ENTRYPOINT_BANNER)
      ? TAG_NAME.ZEE5MUSIC
      : TAG_NAME.LIST_BIG;
  return [
    tagName,
    tags?.includes(TAG_NAME.DIFFERENT_EPISODE_LIST) ||
    tagName.includes(TAG_NAME.NEWS_COLLECTION) ||
    tagName.includes(TAG_NAME.LIST_BIG)
      ? ThumbnailTypes.horizontal
      : tagName.includes(TAG_NAME.COLLECTION) ||
        tagName.includes(TAG_NAME.RECOMMENDED_ARTIST)
      ? ThumbnailTypes.circular
      : tagName === TAG_NAME.ZEE5MUSIC
      ? ThumbnailTypes.bellybanner
      : ThumbnailTypes.vertical
  ];
};

export const mapBreakPointsWithTagsForRails: {
  [key: string]: BreakPointsConfig;
} = {
  horizontal: {
    xl: 7,
    default: 5,
    lg: 3,
    md: 2,
    sm: 1.25
  },
  biggerHorizontal: {
    xl: 6,
    default: 4,
    lg: 2,
    md: 2,
    sm: 1.1
  },
  vertical: {
    xl: 8,
    default: 6,
    lg: 5,
    md: 3.25,
    sm: 3.25
  },
  episode: {
    xl: 7,
    default: 5,
    lg: 3,
    md: 2.25,
    sm: 2.25
  },
  circular: {
    xl: 14.1,
    default: 10.1,
    lg: 6,
    md: 5.6,
    sm: 3.55
  },
  bellybanner: {
    xl: 1,
    default: 1,
    lg: 1,
    md: 1,
    sm: 1
  },
  plex: {
    xl: 3,
    default: 2,
    lg: 2,
    md: 2,
    sm: 1.2
  }
};

export const getBreakPointsConfig = (thumbnailType: ThumbnailTypes) => {
  return mapBreakPointsWithTagsForRails[thumbnailType];
};

/**
 * Identifies the type of a given tag based on predefined categories.
 * @param tag The tag name to be evaluated.
 * @returns The corresponding tag type: ThumbnailTypes.vertical, 'squareTag', 'wideLandscapeTag',
 * or 'landscapeTag' even if tag name is undefined.
 */

export const identifyTagType = (tag?: string | null): string => {
  const tagTypes: Record<string, string> = {
    continueWatching: ThumbnailTypes.vertical,
    portraitSmall: ThumbnailTypes.vertical,
    top10: ThumbnailTypes.vertical,
    portraitLarge: ThumbnailTypes.vertical,
    upcoming: ThumbnailTypes.vertical,
    tvodCard: ThumbnailTypes.vertical,
    portraitSmallBg: ThumbnailTypes.vertical,
    differentepisodelist: ThumbnailTypes.horizontal,
    // collection: ThumbnailTypes.squareTag,
    collection: ThumbnailTypes.circular,
    zee5MusicEntrypointBanner: ThumbnailTypes.bellybanner,
    plexWidget: ThumbnailTypes.plex
  };

  return (tag && tagTypes[tag]) || ThumbnailTypes.horizontal;
};

export enum RailsSkeletonCount {
  ONE = 1,
  TWO = 2,
  THREE = 3
}

export const mapBreakPointsWithTagsForSearchRails: mapBreakPointsWithTagsForRailsInterface =
  {
    horizontal: {
      xl: 6,
      default: 4,
      lg: 3,
      md: 2,
      sm: 1.25
    },
    vertical: {
      xl: 8.5,
      default: 8,
      lg: 5,
      md: 4,
      sm: 3.25
    }
  };

export const getSearchBreakPointsConfig = (thumbnailType: ThumbnailTypes) => {
  return mapBreakPointsWithTagsForSearchRails[thumbnailType];
};
export type BreakPointsConfig = {
  xl: number;
  default: number;
  lg: number;
  md: number;
  sm: number;
};
